import { Input as I } from "antd";

import styled, { css } from "styled-components";

export const FormInputsContainer = styled.div`
  display: grid;
  gap: 16px;
  ${({ mb }) =>
    mb &&
    css`
      margin-bottom: ${mb};
    `}
`;

export const Label = styled.label`
  color: #314158;
  display: inline-block;

  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0px;

  margin-bottom: 8px;

  ${({ mb }) =>
    mb &&
    css`
      margin-bottom: ${mb};
    `}
`;

export const Input = styled(I)`
  width: 100%;
  border: 1.5px solid #dfdfe0;
  height: 48px;
  border-radius: 10px;
  padding: 0 11px;

  font-family: "Inter", sans-serif;
  font-weight: 400px;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0px;
  box-shadow: 0px 1px 2px 0px #19191c0a;

  &::placeholder,
  .ant-input::placeholder {
    color: #68686e;
  }

  ${({ status }) =>
    status === "error" &&
    css`
      &,
      &:hover,
      &:focus {
        border-color: #ff7875 !important;
        box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
        outline: 0;
      }
    `}
`;

export const Error = styled.span`
  color: #ff4d4f;
  display: flex;
  align-items: center;
  gap: 4px;

  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0px;

  margin-top: 8px;
`;

export const RadioGroupContainer = styled.div`
  display: grid;

  .ant-radio-wrapper {
    font-family: "Inter", sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: #68686e;
  }
`;

export const CardBrands = styled.div`
  display: grid;
`;

export const BrandImage = styled.img`
  box-sizing: border-box;
  cursor: pointer;
  height: 53px;
  width: 85px;
  border-radius: 9px;

  &.selected {
    border-radius: 9px;
    border: 1px solid #058ec3;
    box-shadow: 0 0 10px #058ec3;
    outline: 2px solid rgba(5, 142, 195, 0.5);
  }
`;

export const PhoneRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

